import { makeStyles } from '@material-ui/core/styles'
import Color from 'color'

const styles = makeStyles(theme => {
  const pinkColor = Color(theme.palette.pink.main)
  return {
    bid: {
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      margin: 0,
      padding: theme.spacing(1, 2.125),
      paddingRight: theme.spacing(3),
      '&:nth-of-type(even)': {
        backgroundColor: '#F1F1F1'
      }
    },
    chip: {
      flexGrow: 0,
      flexShrink: 0,
      backgroundColor: pinkColor.alpha('.23').string(),
      marginRight: theme.spacing(2.25),
      color: theme.palette.text.primary,
      minWidth: 62
    },
    bidderName: {
      fontFamily: 'Poppins, Open Sans, sans-serif',
      fontSize: '1rem',
      fontWeight: 'normal',
      justifySelf: 'flex-end',
      flexGrow: 1
    },
    bidAmount: {
      fontFamily: 'Poppins, Open Sans, sans-serif',
      fontSize: '1.25rem',
      fontWeight: 'normal'
    },
    winningBid: {
      padding: theme.spacing(2.25, 2.625),
      paddingRight: theme.spacing(3.375),
      color: 'white',
      background:
        'linear-gradient(130deg, rgba(235,46,107,1) 0%, rgba(26,163,255,1) 100%)',
      fallbacks: {
        background: 'rgb(235,46,107)'
      },
      '& $chip': {
        backgroundColor: 'white',
        color: pinkColor.string()
      },
      '& $bidderName': {
        fontWeight: 800
      },
      '& $bidAmount': {
        fontWeight: 800
      }
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/BidList/Bid/styles.js